import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ScheduleYourLegacyAudit from "./sections/ScheduleYourLegacyAudit";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ScheduleYourLegacyAudit />
      <CommonQuestions />
      <Footer />
    </div>;
}